// ============================================================
// 📁 آدرس این فایل در پروژه (فایل جدید):
//    src/pages/tracking/TransitCogsBox.tsx
//
// جعبه‌ی «درخواست‌های هزینه‌ی ترانزیت» که بالای صفحه‌ی COGS گذاشته می‌شود.
// تعداد منتظر تأیید را نشان می‌دهد؛ با زدن، صف کامل (تأیید / رد / ثبت) همان‌جا باز می‌شود.
// ============================================================

import React, { useState, useEffect, useCallback } from "react";
import { transitAPI } from "../../services/api";
import { ExpenseQueue } from "./TransitExpenses";

export default function TransitCogsBox({ T, dark, onChanged }: any) {
  const [open, setOpen] = useState(false);
  const [counts, setCounts] = useState<any>(null);
  const [toast, setToast] = useState<{ t: string; ok: boolean } | null>(null);
  const load = useCallback(async () => {
    try { const r = await transitAPI.expenseList({ status: "requested" }); if (r.success) setCounts(r.counts || {}); } catch { /* بی‌صدا */ }
  }, []);
  useEffect(() => { load(); }, [load]);
  const showToast = (t: string, ok: boolean = true) => { setToast({ t, ok }); setTimeout(() => setToast(null), 3000); };
  const n = counts ? Number(counts.requested || 0) : 0;
  const total = counts ? Object.values(counts).reduce((a: number, b: any) => a + Number(b), 0) : 0;
  if (counts && total === 0) return null; // هیچ درخواستی در کار نیست؛ جعبه نمایش داده نمی‌شود
  return (
    <div dir="rtl" style={{ fontFamily: "'Vazirmatn','Segoe UI',sans-serif", marginBottom: 16, borderRadius: 14, border: `1.5px solid ${n > 0 ? "#f59e0b" : T.cardBorder}`, background: dark ? "rgba(255,255,255,0.03)" : "#fff", overflow: "hidden" }}>
      <div onClick={() => setOpen(o => !o)} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", cursor: "pointer", flexWrap: "wrap", gap: 8, background: n > 0 ? "rgba(245,158,11,0.08)" : "transparent" }}>
        <span style={{ fontSize: 14, fontWeight: 900, color: T.text }}>🚛 درخواست‌های هزینه‌ی ترانزیت
          {n > 0 && <span style={{ marginRight: 10, padding: "2px 12px", borderRadius: 20, background: "#f59e0b", color: "#fff", fontSize: 12, fontWeight: 900 }}>{n} منتظر تأیید</span>}
        </span>
        <span style={{ fontSize: 12.5, color: T.subtext }}>{open ? "▲ بستن" : "▼ باز کردن"}</span>
      </div>
      {open && <div style={{ padding: 16, borderTop: `1px solid ${T.cardBorder}` }}><ExpenseQueue T={T} dark={dark} showToast={showToast} onChanged={() => { load(); if (onChanged) onChanged(); }} /></div>}
      {toast && <div style={{ position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)", zIndex: 99999, padding: "11px 22px", borderRadius: 12, background: toast.ok ? "#059669" : "#dc2626", color: "#fff", fontWeight: 800, fontSize: 13 }}>{toast.t}</div>}
    </div>
  );
}
